import { ApiError } from 'errors/ApiError';
import { ErrorResponse } from './types';

export class SessionError extends ApiError {
  constructor({ error }: { error?: ErrorResponse }) {
    super({
      error,
      title: 'Session expired',
      message: 'Please go back and try getting your quote again.'
    });
    this.name = SessionError.name;
  }
  static get name() {
    return 'SessionError';
  }
}
